<template>
	<div class="c-view-filter">
		<div class="c-view-filter__left">
			<span
				title="Collapse sidebar"
				:class="['btn btn-flat btn-sm', { active: sidebarState === true }]"
				@click="$store.dispatch('dashboard/toggleSidebar')"
			>
				<chevrons-left-icon
					size="1.5x"
					class="custom-class"
				></chevrons-left-icon>
			</span>
			<b-dropdown
				toggle-class="btn-flat"
				id="view-dropdown"
				no-caret
				variant="none"
				size="sm"
				v-if="!currentFolder"
			>
				<template v-slot:button-content>
					<span
						><span class="muted">View | </span
						><span>{{ groupStrategy }}</span></span
					>
				</template>
				<b-dropdown-item @click="onViewChange('domains')">
					<span>Group by domains</span>
					<span class="muted"
						>Items will be grouped under their common domain</span
					>
				</b-dropdown-item>
				<b-dropdown-item @click="onViewChange('pages')">
					<span>Group by pages</span>
					<span class="muted">Items will be grouped page wise</span>
				</b-dropdown-item>
				<b-dropdown-item @click="onViewChange('buckets')">
					<span>Group by buckets</span>
					<span class="muted"
						>Items will be grouped according to their buckets(highlight
						colors)</span
					>
				</b-dropdown-item>
			</b-dropdown>
			<span
				class="btn btn-flat btn-sm"
				v-if="dateFilter"
				@click="$store.dispatch('dashboard/clearFilters')"
			>
				Clear filters <x-icon size="1x"></x-icon>
			</span>
			<b-dropdown
				v-if="!currentFolder"
				toggle-class="btn-flat"
				id="filter-dropdown"
				no-caret
				variant="none"
				size="sm"
			>
				<template v-slot:button-content>
					<span>Filter</span>
					<!-- &nbsp;<chevron-down-icon
            size="1.25x"
          ></chevron-down-icon> -->
				</template>
				<v-date-picker
					:attributes="calendarAttributes.attrs"
					v-model="query.filter.date"
					mode="range"
					:value="null"
					:available-dates="availableDates"
					color="red"
					is-dark
					is-inline
				/>
				<div class="container-fluid">
					<p class="p-small">
						Double tap on a date to select it. Tap two seperate dates to filter
						by date range.
					</p>
				</div>
			</b-dropdown>
			<div class="c-breadcrumbs" v-if="folders.length > 0">
				<span @click="gotoHome"> Home </span>
				<span> / </span>
				<FolderSelect
					size="sm"
					:folderId="currentFolder"
					@change="onFolderUpdate"
					type="flat"
				>
				</FolderSelect>
			</div>
		</div>
		<div class="c-view-filter__middle">
			<input
				placeholder="Search"
				type="text"
				class="form-control"
				v-model="query.search"
			/>
			<x-icon
				size="1.5x"
				class="custom-class"
				v-if="query.search.length > 0"
				@click="clearSearch"
			></x-icon>
		</div>
		<div class="c-view-filter__right">
			<span v-b-tooltip.hover.html="noteCounterText"
				>{{ counter.noteCount }}/{{ counter.total }}</span
			>
		</div>
	</div>
</template>

<script>
import moment from 'moment';
import debounce from '@/lib/debounce';

import {
	XIcon,
	ChevronsLeftIcon,
	LayoutIcon,
	CheckIcon,
} from 'vue-feather-icons';
import FolderSelect from '@/components/ui/folder-select.vue';

export default {
	components: {
		FolderSelect,
		XIcon,
		ChevronsLeftIcon,
		LayoutIcon,
		CheckIcon,
	},
	data: function () {
		return {
			folder: null,
			query: {
				search: '',
				sort: {
					type: 'default', // can be default, time
					asc: false,
				},
				filter: {
					type: 'daterange',
					date: null,
				},
			},
		};
	},
	watch: {
		'query.search': {
			handler: debounce(function (newVal) {
				this.$store.dispatch('dashboard/updateSearch', newVal);
			}, 150),
		},
		'query.filter.date': function (date) {
			console.log(date);
			this.$store.dispatch('dashboard/updateDateFilter', date);
		},
		dateFilter: function (date) {
			this.query.filter.date = date;
		},
		currentFolder: function (folderId) {
			if (folderId) {
				this.folderId = folderId;
			} else {
				this.folderId = null;
			}
		},
	},
	computed: {
		groupStrategy: function () {
			return this.$store.getters['dashboard/groupStrategy'];
		},
		dateFilter: function () {
			return this.$store.getters['dashboard/dateFilter'];
		},
		folders: function () {
			return this.$store.getters['folder/folders'];
		},
		currentFolder: function () {
			return this.$store.getters['dashboard/folder'];
		},
		counter: function () {
			return this.$store.getters['dashboard/counter'];
		},
		notes: function () {
			return this.$store.getters['note/notes'];
		},
		calendarAttributes: function () {
			let notes = this.notes;
			let dates = [];
			for (var i = 0; i < notes.length; i++) {
				dates.push(moment(notes[i].createdAt).local().format());
			}
			return {
				attrs: [
					{
						key: 'today',
						dot: true,
						dates: dates,
					},
				],
			};
		},
		availableDates: function () {
			let currentDate = new Date();
			currentDate.setDate(currentDate.getDate() + 1);
			let dateObject = {
				start: new Date(2020, 6, 7),
				end: currentDate,
			};
			return dateObject;
		},
		noteCounterText: function () {
			let str = `${this.counter.noteCount} out of ${this.counter.total} annotations are shown in this list.`;
			if (this.currentFolder) {
				str = `${this.counter.noteCount} out of ${this.counter.total} annotations in the selected folder are shown in this list.`;
			}
			return '<span>' + str + '</span>';
		},
		sidebarState: function () {
			return this.$store.getters['dashboard/sidebar'];
		},
		currentView: function () {
			return this.$store.getters['dashboard/listView'];
		},
	},
	methods: {
		onViewChange: function (view) {
			this.$store.dispatch('event/trackEvent', {
				name: 'View : Changed',
				data: {
					type: view,
				},
			});
			this.$store.dispatch('dashboard/setGroup', view);
		},
		clearSearch: function () {
			this.query.search = '';
		},
		gotoHome: function () {
			this.$store.dispatch('dashboard/updateFolder', null);
		},
		onFolderUpdate: function (folder) {
			this.$store.dispatch('dashboard/updateFolder', folder);
		},
	},
};
</script>

<style lang="scss">
.c-breadcrumbs {
	padding: var(--size);
	display: inline-flex;
	align-items: center;
	font-size: var(--font-size-sm);
	span {
		padding: 0 var(--margin-sm);
		display: inline-block;
		cursor: pointer;
	}

	.c-folder-select .btn {
		padding: var(--margin-sm);
		background-color: transparent !important;
		background-image: none;
		box-shadow: none !important;
		font-weight: 400;
		font-size: var(--font-size-sm);
		text-shadow: none;
		color: var(--p1);

		&:after {
			content: none;
		}
		&:hover,
		&:active {
			color: #fff;
		}
	}
}

.c-view-filter {
	display: flex;
	justify-content: center;
	padding: var(--margin-lg) var(--margin);
	align-items: center;

	&__left {
		display: flex;
		align-items: center;
		padding: 0 5px;

		.btn {
			margin-right: var(--size-h);

			svg {
				transition: transform 150ms ease-out;
			}

			&.active {
				svg {
					transform: rotate(180deg);
				}
			}
		}
	}

	#view-dropdown {
		button {
			display: flex;
			align-items: center;

			svg {
				margin-left: $sm-margins;
			}
		}
		.dropdown-item {
			flex-direction: column;
			white-space: initial;

			svg {
				margin-left: $sm-base-size;
				color: $green;
				stroke-width: 3px;
			}

			.muted {
				font-size: var(--font-size-xs);
				opacity: 0.75;
			}
		}
	}

	&__middle {
		position: relative;
		flex-grow: 1;
		padding: 0 5px;

		input {
			background-color: transparent;

			&:focus,
			&:hover,
			&:active {
				background-color: rgba(0, 0, 0, 0.35);
			}
		}

		svg {
			position: absolute;
			top: calc(50% - 12px);
			right: 12px;
			cursor: pointer;
		}
	}

	&__right {
		padding: 0 5px;
		font-size: var(--font-size-sm);
		font-weight: 500;
		letter-spacing: 0.3px;
	}

	.vc-title {
		font-size: var(--font-size-sm);
		font-weight: 500;
		letter-spacing: 0.5px;
	}

	@include media-breakpoint-down(xs) {
		flex-wrap: wrap;
		&__right {
			display: none;
		}
		&__left {
			width: 100%;
		}
		&__middle {
			width: 100%;
		}
	}
}
</style>